import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseURL = "https://nft-explorer.p.rapidapi.com";

const createRequest = (url) => ({
  url,
  headers: {
    "x-rapidapi-host": "nft-explorer.p.rapidapi.com",
    "x-rapidapi-key": "0ae130e134msh8b9e3b04d147277p14635djsn6d615e2c5dd8",
  },
});

export const nftApi = createApi({
  reducerPath: "nftApi",
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  endpoints: (builder) => ({
    getNfts: builder.query({
      query: () => createRequest(`/search?chain=eth&filter=global&offset=20&q=ape`),
    }),
    getNftDetails: builder.query({
      query: (nftId) => createRequest(`/search/${nftId}`),
    }),
  }),
});

export const { useGetNftsQuery, useGetNftDetailsQuery } = nftApi;
